import { PAYMENT_METHOD_ENUM, PAYMENT_METHOD_GATEWAY } from 'modules/common/constants/payment-method.enums';

export * from './init-address-value.constant';
export * from './common.columns';
export * from './common.filters';
export * from './init-contact.constant';
export * from './errors.references';
export * from './schedule';
export * from './address';
export * from './entity-type.enum';
export * from './styles';
export * from './payment-method.enums';
export * from './period.enums';
export * from './event-course.status.enum';
export * from './event-course.type.enum';

export const OTHER_CATEGORY_ID = 'OTHER';
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_KEY = 'page';
export const PRODUCT_PAGE_KEY = 'product-page';
export const SERVICE_PAGE_KEY = 'service-page';
export const OFFER_PAGE_KEY = 'offer-page';
export const OPPORTUNITY_PAGE_KEY = 'opportunity-page';
export const CAMPAIGN_TYPE_KEY = 'campaign-type';

export const DEFAULT_COUNTRY_CODE: string = 'CUB';
export const DEFAULT_COUNTRY: string = 'Cuba';

export type ICurrency = 'CUP' | 'USD' | 'EUR' | 'MLC';
export type IPaymentMethod =
  | 'CREDIT_CARD'
  | 'PAYPAL'
  | 'TROPIPAY'
  | 'BANK_TRANSFER'
  | 'INTERNAL_WALLET'
  | 'CASH_ON_PICK_UP';

const DEFAULT_PAYMENT_GATEWAYS = [
  PAYMENT_METHOD_GATEWAY.TM,
  PAYMENT_METHOD_GATEWAY.TROPIPAY,
  PAYMENT_METHOD_GATEWAY.LABERINTO,
];

const DEFAULT_PAYMENT_METHODS = [PAYMENT_METHOD_ENUM.TROPIPAY, PAYMENT_METHOD_ENUM.CREDIT_CARD];

export const supportedCurrencies: ICurrency[] = process.env.REACT_APP_SUPPORTED_CURRENCIES
  ? (process.env.REACT_APP_SUPPORTED_CURRENCIES.split(',') as ICurrency[])
  : ['CUP', 'USD'];

export const supportedPaymentMethods: PAYMENT_METHOD_ENUM[] = DEFAULT_PAYMENT_METHODS;

export const supportedPaymentGateways: PAYMENT_METHOD_GATEWAY[] = (
  process.env.REACT_APP_PAYMENT_GATEWAYS ? process.env.REACT_APP_PAYMENT_GATEWAYS.split(',') : DEFAULT_PAYMENT_GATEWAYS
) as PAYMENT_METHOD_GATEWAY[];

export const NATIONAL_GATEWAYS = [PAYMENT_METHOD_GATEWAY.TM, PAYMENT_METHOD_GATEWAY.ENZONA];
export const INTERNATIONAL_GATEWAYS = [PAYMENT_METHOD_GATEWAY.TROPIPAY, PAYMENT_METHOD_GATEWAY.LABERINTO];
